import React from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap'
import { NavDropdown, MenuItem, Glyphicon, Nav, NavItem, Navbar } from 'react-bootstrap';
import logo from '../../images/exi_logo.png';
import './Menu.css';
import '../css/glyhicon-spinner.css';
import BreadCrumbs from '../Breadcrumbs/BreadCrumbs.js';
import SpinningGlyhicon from '../SpinningGlyhicon.js';
import _ from 'lodash';

export class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.onLogOutClicked = this.onLogOutClicked.bind(this);        
    }

    onLogOutClicked(e) {
        this.props.doLogOut();
    }

    getLoggedOutRender() {
        return <Navbar fluid inverse fixedTop>
            <Navbar.Header>
                <Navbar.Brand>
                    <Link to="/" ><img alt="" src={logo} style={{width:100, height:50}} /></Link>
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
        </Navbar>;
    }

    getFetching(title, fetching, length){        
        return <SpinningGlyhicon fetching={fetching} title={title} length={length}></SpinningGlyhicon>
        
    }
    getProposalMenuItem() {          
        return <LinkContainer to='/proposals'>
            <NavItem eventKey={1} href='/proposals'>
                {this.getFetching("Proposal", this.props.proposals.fetching, this.props.proposals.data.length)}
            </NavItem>
        </LinkContainer>;
        
    }

    getSessionsMenuItem() {              
        return <LinkContainer to='/sessions'>
            <NavItem eventKey={2} href='/sessions'>
                {this.getFetching("Sessions", this.props.sessions.fetching, this.props.sessions.data.length)}                               
            </NavItem>
        </LinkContainer>;
    }

    getJobsMenuItem() {              
        return <LinkContainer to='/jobs'>
            <NavItem eventKey={2} href='/jobs'>
                {this.getFetching("Jobs", this.props.jobs.fetching, this.props.jobs.data.length)}                                   
            </NavItem>
        </LinkContainer>;
    }

    getSelectedMenuItem() {                      
        var count = 0;
        if (this.props.application.selectedDataCollectionGroups){
            count = this.props.application.selectedDataCollectionGroups.length;
        }

        if (this.props.application.selectedDataCollections){
            count = count + this.props.application.selectedDataCollections.length;
        }
        return <LinkContainer to='/selected'>
            <NavItem eventKey={2} href='/selected'>
                { this.getFetching("Selection", false, count)}                               
            </NavItem>
        </LinkContainer>;
    }

    changeTheme(theme){
        var link = _.find(document.getElementsByTagName("link"), function(o){ return o.href.indexOf("bootstrap.min.css") != -1});
        if (link){
            link.setAttribute("href", "https://bootswatch.com/3/" + theme + "/bootstrap.min.css")
        }
    }

    render() {
        /** If there is not sessionId it means that we are not already been authenticated **/
        if ((!this.props.user) || (!this.props.user.token)) {
            return this.getLoggedOutRender();
        }
       
        return (<div>
            <Navbar collapseOnSelect fixedTop inverse>
                <Navbar.Header>
                    <Navbar.Brand>                       
                        <a style={{ fontSize: '16px' }} href="/"> 
                            <img alt="" src={logo} className='logo' style={{width:75, height:40}}/>
                        </a>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                 
                       {this.getProposalMenuItem()}
                       {this.getSessionsMenuItem()}
                        
                        <LinkContainer to='/shipment' disabled>
                             <NavItem eventKey={2} href='/shipment'>
                                 Shipment                               
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to='/prepare' disabled>
                             <NavItem eventKey={3} href='/prepare'>
                                 Prepare Experiment                               
                            </NavItem>
                        </LinkContainer> 
                        {this.props.configuration.dataAnalysis.enabled && 
                            this.getJobsMenuItem()
                        }
                        {this.props.configuration.dataAnalysis.enabled && 
                            this.getSelectedMenuItem()
                        }   
                        
                            
                        
                    
                        

                    </Nav>
                    <Nav pullRight>
                        <NavDropdown  eventKey={4} title={<Glyphicon glyph="cog" />}>                               
                                <NavDropdown  title="Theme">
                                    {this.props.configuration.settings.themes.map((theme, index) => {   
                                        return <MenuItem onClick={(e, theme)=>{this.changeTheme(e.target.text)}} >{theme}</MenuItem>
                                    })}
                                    
                                    
                                </NavDropdown>
                                
                        </NavDropdown>
                        <NavItem eventKey={5} onClick={this.onLogOutClicked} >
                            <Glyphicon glyph="glyphicon glyphicon-log-out" />
                            Log out <strong>{this.props.user.username}</strong>
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <BreadCrumbs breadcrumbsList={this.props.breadcrumbsList}></BreadCrumbs>
        </div>)
    }
}




// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js